export default "__VITE_ASSET__D6E99Dia__"